import angular, { IOnInit } from "angular";
import { ColDef } from "../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import { IRowCommandEventArgs } from "../../../../records/grids/controller";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
  IGridSettings,
} from "../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../records/server/query";
import { MachineConfigurationView } from "../../models/machineConfiguration";
import { ConversionModalOptions } from "./service";
import { GridConfiguration } from "../../../../records/views/recordGridView";
import { machineConfigurationCellClass } from "../machineConfigurationCellClass";

export class ConversionModalComponentController implements IOnInit {
  /* bindings */
  readonly modalInstance!: angular.ui.bootstrap.IModalInstanceService;
  readonly resolve!: { config: ConversionModalOptions };
  config!: ConversionModalOptions;
  /* end bindings */

  readonly gridSettings: IGridSettings;
  readonly defaultQuery: IQuery = {
    CurrentConfiguration: true,
  };

  columns: ColDef[] = [];

  static $inject = [
    ColumnDefinitionServiceName,
    GridSettingsServiceName,
    "environment",
  ];
  gridConfiguration!: GridConfiguration;
  constructor(
    private readonly columnDefinitionService: ColumnDefinitionService,
    gridSettingsService: GridSettingsService,
    private readonly environment: { Date: Date }
  ) {
    this.gridSettings = gridSettingsService.getGridSettings(
      Symbol("machine.conversionmodal")
    );
    this.setModalWidth("950px");
  }

  $onInit(): void {
    this.config = this.resolve.config;
    this.gridConfiguration = this.config.gridConfiguration;
    this.columns = [
      this.columnDefinitionService.getCommandColDef({
        headerName: "select",
        iconClass: "fa fa-plus-circle text-primary",
        name: "select",
        width: 20,
      }),
      ...(this.config.gridConfiguration.columns ?? []),
    ];

    this.columns.forEach((c) => {
      c.cellClass = machineConfigurationCellClass(
        this.environment.Date,
        "CurrentConfiguration",
        "Date"
      );
    });
  }

  onItemCommand(args: IRowCommandEventArgs<MachineConfigurationView>) {
    switch (args.commandName) {
      case "select":
        this.modalInstance.close({
          machineId: args.data.MachineId,
          machineConfigurationId: args.data.Id,
        });
    }
  }
  currentConfigurationChanged(currentConfigurationsOnly: boolean) {
    if (!currentConfigurationsOnly) {
      this.defaultQuery.CurrentConfiguration = undefined;
    }
  }

  newConversion() {
    this.modalInstance.close({
      machineId: undefined,
      machineConfigurationId: undefined,
    });
  }

  private setModalWidth(width: string) {
    const elements = document.querySelector(".modal-content");
    if (!elements) return;
    var modalWindow = angular.element(elements);
    modalWindow.css("width", width);
  }
}
